import DropdownToggle from '../../../DropdownToggle/index';

import styles from './FooterNavGroupTitle.module.css';

/** The UK footer style only — the other one is a cxy `Accordion.Item` since NGF-7074. */
type FooterNavGroupTitleProps = {
  isOpen: boolean;
  isUkFooterStyle: true;
  subLinksId: string;
  title: string;
  toggle(): void;
};

export const FooterNavGroupTitle = ({ isOpen, subLinksId, title, toggle }: FooterNavGroupTitleProps) => {
  return (
    <>
      <button
        aria-controls={subLinksId}
        aria-expanded={isOpen}
        className={styles.footerNavGroupTitleButtonUk}
        onClick={toggle}
        type="button"
      >
        <span className={styles.footerNavGroupTitleTextUk}>{title}</span>
        <DropdownToggle isOpen={isOpen} />
      </button>
      <p className={styles.footerNavGroupTitleDesktopUk}>{title}</p>
    </>
  );
};
